import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils'
import { keepDuplicate } from '../query-api'

interface UseKeepDuplicateProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useKeepDuplicate = (props?: UseKeepDuplicateProps) => {
  const { onError, onSuccess } = props || {}
  const queryClient = useQueryClient()

  const { mutate: keepBoth, ...rest } = useMutation(keepDuplicate, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.AttachmentsList)
      onSuccess?.()
    },
    onError: (error?: APIError) => {
      onError?.(error)
    },
  })

  return { keepBoth, ...rest }
}
